module.exports = __webpack_public_path__ + "img/md-item01.d3127ad.png";